import "../../../../../css/CashflowModeller2/Buttons/RadioButton.css";

/**
 * RadioButton component renders a group of radio buttons based on the provided options.
 *
 * @param {Object} props - The component props.
 * @param {Array<{ name: string }>} props.options - Array of option objects, each with a `name` property to display as the radio button label.
 * @param {string} props.selected - The currently selected option's name.
 * @param {function} props.onChange - Callback function called when a radio button is selected. Receives the selected option's name as an argument.
 *
 * @returns {JSX.Element} The rendered RadioButton component.
 */
const RadioButton = ({ options, selected, onChange }) => {
  return (
    <div className="radiobutton-Container">
      {options.map((person) => {
        const firstName = person.name;
        return (
          <div className="radiobutton-Container" key={firstName} onClick={() => onChange(firstName)}>
            <label className="radiooption">
              <input
                className="radiobutton"
                type="radio"
                name="person"
                value={firstName}
                checked={selected === firstName}
                onChange={() => onChange(firstName)}
              />
              <span className="Custom-radiobutton"></span>
            </label>
            <div className="Input">{firstName}</div>
          </div>
        );
      })}
    </div>
  );
};

export default RadioButton;
